//* 답례품 배송(GiftDelivery) 상태의 운영 표기 단일 출처.
//* 화환의 @shared/utils/orderStatusLabel 과 같은 역할 — 화면마다 Record를 따로 두다 보니
//* 같은 상태를 다르게 부르고 있었다(`주소대기` vs `배송지대기`).
//*
//* 함수명에 gift 접두를 붙인 건 orderStatusLabel의 동명 함수(화환 ShopOrder용)와
//* import 지점에서 헷갈리지 않게 하기 위해서다.

import { GiftDeliveryStatus } from '@shared/api/giftDelivery/giftDelivery.interface';

export interface GiftStatusBadge {
  label: string;
  className: string;
}

//* `주소`보다 `배송지`가 무엇의 주소인지 드러나서 이쪽으로 통일했다
export const GIFT_DELIVERY_STATUS_LABEL: Record<GiftDeliveryStatus, string> = {
  [GiftDeliveryStatus.WaitingAddress]: '배송지대기',
  [GiftDeliveryStatus.AddressSubmitted]: '배송지입력',
  [GiftDeliveryStatus.Preparing]: '준비중',
  [GiftDeliveryStatus.Shipping]: '배송중',
  [GiftDeliveryStatus.Delivered]: '배송완료',
  [GiftDeliveryStatus.Canceled]: '취소',
};

const GIFT_DELIVERY_STATUS_CLASS: Record<GiftDeliveryStatus, string> = {
  [GiftDeliveryStatus.WaitingAddress]: 'bg-orange-100 text-orange-800',
  [GiftDeliveryStatus.AddressSubmitted]: 'bg-cyan-100 text-cyan-800',
  [GiftDeliveryStatus.Preparing]: 'bg-yellow-100 text-yellow-800',
  [GiftDeliveryStatus.Shipping]: 'bg-blue-100 text-blue-800',
  [GiftDeliveryStatus.Delivered]: 'bg-green-100 text-green-800',
  [GiftDeliveryStatus.Canceled]: 'bg-gray-100 text-gray-500',
};

//* 모르는 값이 오면 원문을 그대로 — 서버가 상태를 늘렸을 때 화면이 빈칸이 되는 것보다 낫다
export const giftDeliveryStatusLabel = (status?: string): string =>
  GIFT_DELIVERY_STATUS_LABEL[status as GiftDeliveryStatus] ?? status ?? '-';

export const giftDeliveryStatusBadge = (status?: string): GiftStatusBadge => ({
  label: giftDeliveryStatusLabel(status),
  className:
    GIFT_DELIVERY_STATUS_CLASS[status as GiftDeliveryStatus] ??
    'bg-gray-100 text-gray-600',
});
